import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import { Card } from 'components/UI';
import i18n from 'i18n-js';
import Loading from 'components/Loading';
import { OptionalItemsTable } from 'components/Subscriptions';
import { OptionalItemsModal } from 'components/Modals';
import { SubscriptionsActions } from 'state/modules/subscriptions';

const OptionalItemsWidget = ({ id }) => {
  const { loading, subscription } = useSelector((state) => state.subscriptions);

  const dispatch = useDispatch();

  const [openOptionalItems, setOpenOptionalItems] = useState(false);

  const handleOptionalItemsModalOpen = () => {
    if (!openOptionalItems) dispatch(SubscriptionsActions.resetUpdateSubscription());
    setOpenOptionalItems((prevState) => !prevState);
  };

  /**
   * Vertical menu list
   * It has the label and the function for each action
   */
  const items = [];

  if (subscription?.status?.toLowerCase() === 'pending') {
    items.push({
      title: i18n.t('subscriptions.add_optional_item'),
      onClick: handleOptionalItemsModalOpen,
    });
  }

  return (
    <Card
      headerActionType="vertical"
      data-cy="optional-items-widget-card"
      menuItems={items}
      menuPermissions={{
        action: 'update',
        subject: 'subscription',
        type: 'can',
      }}
      title={i18n.t('subscriptions.optional_items')}
    >
      {loading ? (
        <Box justifyContent="center" alignItems="center" display="flex">
          <Loading />
        </Box>
      ) : (
        <OptionalItemsTable pricing={subscription?.pricing || []} />
      )}
      {openOptionalItems && (
        <OptionalItemsModal open={true} id={id} handleClick={handleOptionalItemsModalOpen} />
      )}
    </Card>
  );
};

export default OptionalItemsWidget;
